import * as e from "react";
import c from "../lib/IconBase.es.js";
import t from "../defs/Placeholder.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(c, { ref: a, ...r, weights: t }));
o.displayName = "PlaceholderIcon";
const s = o;
export {
  s as Placeholder,
  o as PlaceholderIcon
};
